import CryptoJS from "crypto-js";
const key = CryptoJS.enc.Utf8.parse("HPwPsB8j5DsaYM4D"); // 作为密钥
const iv = CryptoJS.enc.Utf8.parse("NsEwYSKHm89Xwomo"); // 作为密钥偏移量

export function  encode (word ){
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    // return encrypted.ciphertext.toString().toUpperCase();
    return encrypted.toString();
}
export function decode (word){
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
